<template>
  <p>
    O cancelamento estará disponível entre 07h e 23:45h.
  </p>
</template>
